import { render, staticRenderFns } from "./AnalysesHeroSearch.vue?vue&type=template&id=1a26e0e4&scoped=true&"
import script from "./AnalysesHeroSearch.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AnalysesHeroSearch.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AnalysesHeroSearch.vue?vue&type=style&index=0&id=1a26e0e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a26e0e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a26e0e4')) {
      api.createRecord('1a26e0e4', component.options)
    } else {
      api.reload('1a26e0e4', component.options)
    }
    module.hot.accept("./AnalysesHeroSearch.vue?vue&type=template&id=1a26e0e4&scoped=true&", function () {
      api.rerender('1a26e0e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/diagnostika/analiz/components/AnalysesHeroSearch.vue"
export default component.exports